module.exports = __webpack_public_path__ + "static/img/14.ac69328.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/2/4/sp/14.png
// module id = +4v8
// module chunks = 0